/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useAuth } from '../../../../app/modules/auth'
import { Link, useNavigate } from 'react-router-dom'
import { executePost } from '../../../../configs/Kubuku'
import { PROFILE } from '../../../../api'

type User = {
  name: string
  logo: string
}

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth()
  const navigate = useNavigate()
  const [profile, setProfile] = useState<User>({ name: '', logo: '' })

  useEffect(() => {
    const getDataProfile = async () => {
      try {
        const formData = new FormData()
        const response = await executePost(PROFILE, formData)
        const dataProfile = response?.data

        setProfile(dataProfile)
      } catch (error) {
        console.error('Data tidak ada: ', error)
      }
    }
    getDataProfile()
  }, [])

  const signout = () => {
    try {
      localStorage.clear()
      navigate('/')
      window.location.reload()
    } catch (error) {
      console.error('Error occurred while signing out:', error)
    }
  }
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-semibold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>

          <div className='d-flex flex-column'>
            <div className='fw-bold d-flex align-items-center fs-5 mb-4'>
              {/* {currentUser?} */}
              <span className='badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2'>
                {currentUser?.user.nama}
              </span>
            </div>
            <div className='fw-bold d-flex align-items-center fs-5'>
              {/* {currentUser?} */}
              <span className='badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2'>
                {currentUser?.user.email}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className='menu-item px-5 my-1'>
        {/* <Link to='/crafted/account/settings' className='menu-link px-5'>
          Account Settings
        </Link> */}
      </div>

      <div className='menu-item px-5'>
        <a onClick={signout} className='menu-link px-5'>
          Keluar
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
